import { RoutablePage, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { USER_LOGOUT_KEYCLOAK } from '@gig/magic-messages';

/**
 * Account closure success page. User is automatically logged out and redirected
 * to homepage after 10 seconds
 */
var AccountClosureSuccessComponent = /** @class */ (function (_super) {
    __extends(AccountClosureSuccessComponent, _super);
    function AccountClosureSuccessComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountClosureSuccessComponent.prototype.mounted = function () {
        var _this = this;
        var DELAY_BEFORE_REDIRECT = 10000;
        setTimeout(function () {
            window.commandBus.publish(USER_LOGOUT_KEYCLOAK, _this.getFullHref({ route: RoutablePage.ACCOUNT_CLOSURE_DONE }));
        }, DELAY_BEFORE_REDIRECT);
    };
    AccountClosureSuccessComponent = __decorate([
        Component({
            name: 'corex-account-closure-success',
        })
    ], AccountClosureSuccessComponent);
    return AccountClosureSuccessComponent;
}(Mixins(MagicConfigMixin)));

export default AccountClosureSuccessComponent;
